<template>
  <div class="page-dashboard scrollable only-y">
    <div class="page-header" v-loading="loading"
         element-loading-text="Dashboard Verileri Getiriliyor. Lütfen Bekleyiniz."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(243,247,250,255)">
      <el-collapse v-if="isData" v-model="activeNames" class="dashboard-collapse-area">
        <el-row :gutter="20">
          <el-col :lg="12" :md="12" :sm="24" :xs="24" class="margin-bottom-20">
            <el-badge :value="evrak.gelenEvrakCount" style="z-index: 999;" class="item anasayfa"/>
            <el-collapse-item class="animated fadeInUp" title="Giden Evraklar" name="1">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table border :data="evrak.gelenEvrak" style="width: 100%">
                  <el-table-column label='Dosya' align="left" width="150">
                    <template slot-scope="scope">
                      <div>
                        <el-tooltip v-if="scope.row.dosyaAdi == null" content='Dosya Yükle' :open-delay="500"
                                    placement="bottom" class="upload-tooltip">
                          <el-upload class="upload"
                                     :file-list="evrakListMain.findIndex(item=> item.yaziIsleriID == scope.row.yaziIsleriID) != -1 ? evrakListMain : []"
                                     :id="'evrakEkle_' + scope.row.yaziIsleriID" action="" :auto-upload="false"
                                     :limit="1"
                                     :on-change="file => evrakUpload(file, scope.row,'gelenEvrak')"
                                     :on-remove="evrakRemove" list-type="belge-card" accept="">
                            <el-button :loading="guncellenenEvrakID == scope.row.yaziIsleriID" v-if="yetkiTuru != '3'"
                                       class="upload-btn"
                                       type="primary">
                              <i v-if="guncellenenEvrakID != scope.row.yaziIsleriID"
                                 class="mdi mdi-cloud-upload mdi-20px"/>
                            </el-button>
                          </el-upload>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="kayitKodu" label="Evrak No" width="180"/>
                  <el-table-column prop="cariAdi" label="Cari"/>
                  <el-table-column prop="konu" label="Konu"/>
                  <el-table-column prop="yaziIsleriID" label="">
                    <template slot-scope="scope">
                      <el-tooltip content='Düzenle' :open-delay="500" placement="bottom">
                        <el-button @click="goEvrakDetay(scope.row.yaziIsleriID);" class="download-btn edit-btn"
                                   type="primary">
                          <i class="mdi mdi-pen mdi-20px"></i>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
          <el-col :lg="12" :md="12" :sm="24" :xs="24" class="margin-bottom-20">
            <el-badge :value="evrak.gidenEvrakCount" style="z-index: 999;" class="item anasayfa"/>
            <el-collapse-item class="animated fadeInUp" title="Gelen Evraklar" name="2">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table border :data="evrak.gidenEvrak" style="width: 100%">
                  <el-table-column label='Dosya' align="left" width="150">
                    <template slot-scope="scope">
                      <div>
                        <el-tooltip v-if="scope.row.dosyaAdi == null" content='Dosya Yükle' :open-delay="500"
                                    placement="bottom" class="upload-tooltip">
                          <el-upload class="upload"
                                     :file-list="evrakListMain.findIndex(item=> item.yaziIsleriID == scope.row.yaziIsleriID) != -1 ? evrakListMain : []"
                                     :id="'evrakEkle_' + scope.row.yaziIsleriID" action="" :auto-upload="false"
                                     :limit="1"
                                     :on-change="file => evrakUpload(file, scope.row,'gidenEvrak')"
                                     :on-remove="evrakRemove" list-type="belge-card" accept="">
                            <el-button :loading="guncellenenEvrakID == scope.row.yaziIsleriID" v-if="yetkiTuru != '3'"
                                       class="upload-btn"
                                       type="primary">
                              <i v-if="guncellenenEvrakID != scope.row.yaziIsleriID"
                                 class="mdi mdi-cloud-upload mdi-20px"/>
                            </el-button>
                          </el-upload>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="kayitKodu" label="Evrak No" width="180"/>
                  <el-table-column prop="cariAdi" label="Cari"/>
                  <el-table-column prop="konu" label="Konu"/>
                  <el-table-column prop="yaziIsleriID" label="">
                    <template slot-scope="scope">
                      <el-tooltip content='Düzenle' :open-delay="500" placement="bottom">
                        <el-button @click="goEvrakDetay(scope.row.yaziIsleriID);" class="download-btn edit-btn"
                                   type="primary">
                          <i class="mdi mdi-pen mdi-20px"></i>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="12" :md="12" :sm="24" :xs="24" class="margin-bottom-20">
            <el-badge :value="tarihler.count" style="z-index: 999;" class="item anasayfa"/>
            <el-collapse-item v-loading="yaklasanTarihLoading" class="animated fadeInUp" title="Yaklaşan Tarihler"
                              name="3">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-row>
                  <el-col :xl="12" :lg="12" :md="12" :sm="24">
                    <el-radio-group @change="yaklasanTarihTurChange" v-model="tarihler.tur" size="mini"
                                    style="float: left;margin-left: 10px"
                                    class="yaklasan-tarihler-tur-checkbox">
                      <el-radio-button label="1"> Tahsis</el-radio-button>
                      <el-radio-button label="2"> Yapı</el-radio-button>
                      <el-radio-button label="3">Açma</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :xl="12" :lg="12" :md="12" :sm="24">
                    <el-radio-group @change="yaklasanTarihGunChange" v-model="tarihler.gun" size="mini"
                                    style="float:right;margin-right: 10px;" class="yaklasan-tarihler-gun-checkbox">
                      <el-radio-button label="30"> {{ tarihler.gun == '30' ? '30 Gün' : '30' }}</el-radio-button>
                      <el-radio-button label="60"> {{ tarihler.gun == '60' ? '60 Gün' : '60' }}</el-radio-button>
                      <el-radio-button label="90"> {{ tarihler.gun == '90' ? '90 Gün' : '90' }}</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-table border :data="tarihler.list" style="width: 100%">
                  <el-table-column prop="musteriAdi" label="Yatırımcı Adı"/>
                  <el-table-column prop="projeBaslik" label="Yatırım Adı"/>
                  <el-table-column prop="arsaTahsisTarihi" label="Arsa Tahsis T."/>
                  <el-table-column prop="yapiRuhsatTarihi" label="Yapı Ruhsat T."/>
                  <el-table-column prop="isYeriAcmaRuhsatTarihi" label="İş Yeri Açma T."/>
                  <el-table-column prop="projeID" label="" width="80">
                    <template slot-scope="scope">
                      <el-tooltip content='Düzenle' :open-delay="500" placement="bottom">
                        <el-button @click="goYatirimGuncelle(scope.row.id);" class="download-btn edit-btn"
                                   type="primary">
                          <i class="mdi mdi-pen mdi-20px"></i>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
          <el-col :lg="12" :md="12" :sm="24" :xs="24" class="margin-bottom-20">
            <el-badge :value="girilmeyenTarihler.count" style="z-index: 999;" class="item anasayfa"/>
            <el-collapse-item class="animated fadeInUp" title="Girilmeyen Tarihler"
                              name="4">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table border :data="girilmeyenTarihler.list" style="width: 100%">
                  <el-table-column prop="musteriAdi" label="Yatırımcı Adı"/>
                  <el-table-column prop="projeBaslik" label="Yatırım Adı"/>
                  <el-table-column prop="arsaTahsisTarihi" label="Arsa Tahsis Tarihi"/>
                  <el-table-column prop="yapiRuhsatTarihi" label="Yapı Ruhsat Tarihi"/>
                  <el-table-column prop="isYeriAcmaRuhsatTarihi" label="İş Yeri Açma Tarihi"/>
                  <el-table-column prop="projeID" label="" width="80">
                    <template slot-scope="scope">
                      <el-tooltip content='Düzenle' :open-delay="500" placement="bottom">
                        <el-button @click="goYatirimGuncelle(scope.row.id);" class="download-btn edit-btn"
                                   type="primary">
                          <i class="mdi mdi-pen mdi-20px"></i>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="8" :md="8" :sm="24" :xs="24" class="margin-bottom-20">
            <!--            <el-badge :value="evrak.gidenEvrakCount" style="z-index: 999;" class="item anasayfa"/>-->
            <el-collapse-item class="animated fadeInUp" title="Arsa Tahsis (Son 10 Kayıt)" name="5">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table border :data="arsa.tahsis" style="width: 100%">
                  <el-table-column prop="yatirimci" label="Yatırımcı"/>
                  <el-table-column prop="projeAdi" label="Yatırım Adı"/>
                  <el-table-column prop="projeID" label="" width="100">
                    <template slot-scope="scope">
                      <el-tooltip content='Detay' :open-delay="500" placement="bottom">
                        <el-button @click="goArsaDetay(scope.row);" class="download-btn" type="primary">
                          <i class="mdi mdi-eye-outline mdi-20px"></i>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
          <el-col :lg="8" :md="8" :sm="24" :xs="24" class="margin-bottom-20">
            <!--            <el-badge :value="evrak.gidenEvrakCount" style="z-index: 999;" class="item anasayfa"/>-->
            <el-collapse-item class="animated fadeInUp" title="Yapı Ruhsat (Son 10 Kayıt)" name="6">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table border :data="arsa.yapi" style="width: 100%">
                  <el-table-column prop="yatirimci" label="Yatırımcı"/>
                  <el-table-column prop="projeAdi" label="Yatırım Adı"/>
                  <el-table-column prop="projeID" label="" width="100">
                    <template slot-scope="scope">
                      <el-tooltip content='Detay' :open-delay="500" placement="bottom">
                        <el-button @click="goYapiRuhsatDetay(scope.row);" class="download-btn" type="primary">
                          <i class="mdi mdi-eye-outline mdi-20px"></i>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
          <el-col :lg="8" :md="8" :sm="24" :xs="24" class="margin-bottom-20">
            <!--            <el-badge :value="evrak.gidenEvrakCount" style="z-index: 999;" class="item anasayfa"/>-->
            <el-collapse-item class="animated fadeInUp" title="Açma Ruhsat (Son 10 Kayıt)" name="7">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table border :data="arsa.acma" style="width: 100%">
                  <el-table-column prop="yatirimci" label="Yatırımcı"/>
                  <el-table-column prop="projeAdi" label="Yatırım Adı"/>
                  <el-table-column prop="projeID" label="" width="100">
                    <template slot-scope="scope">
                      <el-tooltip content='Detay' :open-delay="500" placement="bottom">
                        <el-button @click="goCalismaRuhsatDetay(scope.row);" class="download-btn" type="primary">
                          <i class="mdi mdi-eye-outline mdi-20px"></i>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="12" :md="12" :sm="24" :xs="24" class="margin-bottom-20">
            <el-collapse-item class="animated fadeInUp" title="Yatırımcılar (Son 10 Kayıt)" name="8">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table border :data="yatirimci.list" style="width: 100%">
                  <el-table-column prop="musteriAdi" label="Yatırımcı"/>
                  <el-table-column prop="unvan" label="Unvan"/>
                  <el-table-column prop="adres" label="Adres"/>
                  <el-table-column prop="telefon" label="Telefon"/>
                  <el-table-column prop="eposta" label="E-Posta">
                    <template slot-scope="scope">
                      <div style="line-height: 16px!important;">
                        {{ scope.row.eposta }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="musteriID" label="" width="80">
                    <template slot-scope="scope">
                      <el-tooltip content='Düzenle' :open-delay="500" placement="bottom">
                        <el-button @click="goYatirimci(scope.row.musteriID);" class="download-btn edit-btn"
                                   type="primary">
                          <i class="mdi mdi-pen mdi-20px"></i>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
          <el-col :lg="12" :md="12" :sm="24" :xs="24" class="margin-bottom-20">
            <el-collapse-item class="animated fadeInUp" title="Yatırımlar (Son 10 Kayıt)" name="9">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table stripe border :data="yatirim.list" style="width: 100%">
                  <el-table-column prop="projeBaslik" label="Proje Adı"/>
                  <el-table-column prop="alan" label="Alan" width="180"/>
                  <el-table-column prop="ada" label="Ada" width="180"/>
                  <el-table-column prop="parsel" label="Parsel" width="180"/>
                  <el-table-column prop="id" label="" width="80">
                    <template slot-scope="scope">
                      <el-tooltip content='Düzenle' :open-delay="500" placement="bottom">
                        <el-button @click="goYatirim(scope.row.id);" class="download-btn edit-btn"
                                   type="primary">
                          <i class="mdi mdi-pen mdi-20px"></i>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="24" :md="12" :sm="24" :xs="24" class="margin-bottom-20">
            <el-badge :value="muhasebe.count" style="z-index: 999;" class="item anasayfa"/>
            <el-collapse-item class="animated fadeInUp" title="Muhasebe Dekontsuz Talimatlar" name="10">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table border :data="muhasebe.list" style="width: 100%">
                  <el-table-column label='Dekont' align="left" width="300">
                    <template slot-scope="scope">
                      <div class="flex">
                        <el-tooltip content='Dekont Yükle'
                                    :open-delay="500" placement="bottom" class="upload-tooltip">
                          <el-upload class="upload"
                                     :file-list="dekontListMain.findIndex(item=> item.muhasebeID == scope.row.muhasebeID) != -1 ? dekontListMain : []"
                                     :id="'evrakEkle_' + scope.row.muhasebeID" action="" :auto-upload="false" :limit="1"
                                     :on-change="file => talimatUpload(file, scope.row)"
                                     :on-remove="evrakRemove" list-type="belge-card" accept="">

                            <el-button :loading="updateTalimatID == scope.row.muhasebeID" v-if="yetkiTuru != '3'"
                                       class="upload-btn"
                                       type="primary">
                              <i v-if="updateTalimatID != scope.row.muhasebeID"
                                 class="mdi mdi-cloud-upload mdi-20px"></i>
                            </el-button>
                          </el-upload>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sablonAdi" label="Şablon"/>
                  <el-table-column prop="tarih" label="Tarih" width="180"/>
                  <el-table-column label='İşlem' width="240">
                    <template slot-scope="scope">
                      <el-tooltip content='Talimat Detay'
                                  :open-delay="500" placement="bottom">
                        <el-button @click="talimetDetay(scope.row)" type="text" class="islem-button"
                                   style="color: #86A7FC;">
                          <i class="mdi mdi-file-document-outline mdi-24px"/>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="24" :md="12" :sm="24" :xs="24" class="margin-bottom-20">
            <el-badge :value="adminLog.count" style="z-index: 999;" class="item anasayfa"/>
            <el-collapse-item class="animated fadeInUp" title="Loglar" name="11">
              <div class="scrollable only-y" style="max-height: 260px !important;">
                <el-table border :data="adminLog.list" style="width: 100%">
                  <el-table-column prop="ip1" label="IP1"/>
                  <el-table-column prop="modulAdi" label="Modül"/>
                  <el-table-column prop="olusturan" label="İşlem Sahibi" width="180"/>
                  <el-table-column prop="olusumTarihi" label="İşlem Tarihi" width="180">
                    <template slot-scope="scope">
                      {{ scope.row.olusumTarihi.slice(0, 16) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="yol" label="Dosya" width="180">
                    <template slot-scope="prop">
                      <el-button @click="adminLogDownloadFile(prop.row)" class="download-btn" type="primary"><i
                          class="mdi mdi-download mdi-20px"></i></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-col>
        </el-row>
      </el-collapse>
    </div>
    <el-dialog title="Talimat Detay" :visible.sync="talimatDialogVisible" width="50%">
      <el-row class="mb-10">
        <el-col :span="24">
          <el-image @click="talimatDownloadFile(talimatData)" v-if="talimatData.dekont"
                    :src="talimatService.dekontPath+talimatData.dekont"
                    style="width: 100px; height: 100px;cursor: pointer"/>
        </el-col>
        <el-col :span="24">
          <el-upload class="upload" action="" :auto-upload="false" :limit="1" list-type="belge-card" accept=""
                     :on-change="file => dekontUpload(file, talimatData)" :on-remove="evrakRemove"
                     :file-list="dekontListMain.findIndex(item=> item.muhasebeID == talimatData.muhasebeID) != - 1 ? dekontListMain : []"
                     style="display: inline-block">
            <el-button :loading="evrakLoading" v-if="yetkiTuru != '3'" class="upload-btn" type="primary"
                       style="width: 120px!important;">
              {{ !talimatData.dekont ? 'Dekont Yükle' : 'Dekontu Değiştir' }}
            </el-button>
          </el-upload>
          <el-button @click="talimatUpdateCancel" type="primary" size="small" class="mt-10"
                     :style="{backgroundColor: isTalimatUpdate ? '#FF9843' : '#39A7FF'}"
                     style="float: right;border:none">
            {{ isTalimatUpdate ? 'Vazgeç' : 'Talimatı Düzenle' }}
          </el-button>
        </el-col>
      </el-row>
      <ckeditor :disabled="!isTalimatUpdate" :editor="editor" :config="editorConfig"
                v-model="talimatData.sablon_icerik"/>
      <el-row>
        <el-col :span="24" class="justify-flex-end flex">
          <el-button v-if="isTalimatUpdate" @click="talimatUpdate" type="primary" size="small" class="mt-10"
                     style="background-color: #39A7FF;border: none;">Kaydet
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import notification from '../../notification'
import Vue from 'vue'
import excel from 'vue-excel-export'
import EventBus from '@/components/event-bus'
import analitikService from "../../WSProvider/AnalitikService"
import dosyaService from "@/WSProvider/DosyaService";
import arsaService from "@/WSProvider/ArsaService";
import ruhsatService from "@/WSProvider/RuhsatService";
import calismaRuhsatService from "@/WSProvider/CalismaRuhsatService";
import logService from "@/WSProvider/LogService";
import talimatService from "@/WSProvider/TalimatService";
import JQuery from 'jquery';
import functions from "@/functions";
import CKeditor from "@ckeditor/ckeditor5-build-classic";

let $ = JQuery;

Vue.use(excel);

export default {
  name: 'Dashboard',
  computed: {
    talimatService() {
      return talimatService
    },
    logService() {
      return logService
    }
  },
  components: {},
  data() {
    return {
      evrakLoading: false,
      dekontForm: {
        evrakTarihi: "",
        durum: '1',
        cariID: "",
        evrak: [],
        evrakID: '',
        evrakAdi: ''
      },
      talimatDekontListMain: [],
      talimatData: [],
      isTalimatUpdate: false,
      editor: CKeditor,
      editorConfig: {
        language: 'tr',
      },
      dekontListMain: [],
      talimatDialogVisible: null,
      updateTalimatID: null,
      isData: false,
      guncellenenEvrakID: null,
      resized: false,
      yaklasanTarihLoading: false,
      loading: false,
      islemList: [],
      yonetimListe: [],
      yetkiTuru: "",
      evrak: {
        gelenEvrak: [],
        gidenEvrak: [],
        gelenEvrakCount: 0,
        gidenEvrakCount: 0,
      },
      arsa: {
        tahsis: [],
        yapi: [],
        acma: [],
        tahsisCount: 0,
        yapiCount: 0,
        acmaCount: 0,
      },
      yatirimci: {
        list: [],
      },
      yatirim: {
        list: [],
      },
      muhasebe: {
        list: [],
        count: 0,
      },
      tarihler: {
        list: [],
        count: 0,
        gun: '30',
        tur: 1,
      },
      girilmeyenTarihler: {
        list: [],
        count: 0,
      },
      adminLog: {
        list: [],
        count: 0,
      },
      radio1: 'Month',
      radio2: 'Week',
      root: false,
      yetkili: false,
      excelTable: [],
      asyncComponent: 'peity',
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'],
      // activeNames: ['1'],
      listKey: 0,
      evrakListMain: [],
      talimatListMain: [],
      evrakForm: {
        evrakTarihi: "",
        durum: '1',
        cariID: "",
        evrak: [],
        evrakID: '',
        evrakAdi: ''
      },
    }
  },
  mounted() {
    this.yetkiTuru = this.$store.getters.getYetkiTuru
    this.getDashboard();
    let self = this;
    EventBus.$on('dashboard', function (bool) {
      if (bool) {
        self.getDashboard();
      }
    });
    this.root = true
  },
  methods: {
    // ? Talimat
    dekontUpload(file, row, formName) {
      this.$set(row, 'dosyaYuklendi', true);
      const item = {
        name: file.name,
        url: file.url,
        id: file.raw.lastModified,
        size: file.raw.size,
        muhasebeID: row.muhasebeID,
      };
      this.dekontListMain.push(item)
      file.raw["tmp_name"] = file.url;
      this.dekontForm.evrak.push(file.raw);
      this.$forceUpdate();
      //row.dosyaYuklendi = false;
      this.$confirm("Dekont Eklemek İstediğinize Emin Misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        this.updateTalimatID = row.muhasebeID
        this.evrakLoading = true;
        talimatService.dekontEkle(row.muhasebeID, this.dekontForm.evrak[0], 'update').then((response) => {
          if (response.status == 200) {
            this.getDashboard();
            this.talimatDialogVisible = false
            localStorage.setItem("userDataDemirag", response.token)
            notification.Status("success", this, response.msg)
            this.refreshPage(row.dosyaDurumu)
            this.resetForm(formName)
          }
          this.evrakLoading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          this.evrakLoading = false;
        }).finally(() => {
          const findIndex = this.dekontListMain.findIndex(item => item.muhasebeID == row.muhasebeID)
          this.dekontListMain.splice(findIndex, 1)
          this.dekontForm.evrak = []
          this.dialogVisible = false
          this.updateTalimatID = null
          this.evrakLoading = false
        })
      }).catch((e) => {
        const findIndex = this.dekontListMain.findIndex(item => item.muhasebeID == row.muhasebeID)
        this.dekontListMain.splice(findIndex, 1)
        this.dekontForm.evrak = []
      })
    },
    talimetDetay(item = this.talimatData) {
      talimatService.talimatDetay(item.muhasebeID).then((response) => {
        localStorage.setItem("userDataDemirag", response.token)
        if (response.status == 200) {
          this.talimatData = response.data;
          this.talimatDialogVisible = true
        }
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
            this.talimatData = []
          } else notification.Status("errorMsg", this, error.errMsg)
        } else {
          //notification.Status(503, this)
        }
      })
    },
    talimatUpdateCancel() {
      if (this.isTalimatUpdate) {
        this.isTalimatUpdate = false
        this.talimetDetay()
      } else {
        this.isTalimatUpdate = true
      }
    },
    talimatDownloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = talimatService.dekontPath + item.dekont;
      downloadLink.download = item.dekont;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    // ? >
    goYatirim(id) {
      this.$store.commit('changeProjeUpdateData', id)
      functions.routeSayfa("Yatırım Güncelle", this)
    },
    goYatirimci(id) {
      this.$store.commit('changeMusteriUpdateData', id)
      functions.routeSayfa("Yatırımcı Güncelle", this)
    },
    goYatirimGuncelle(id) {
      this.$store.commit('changeProjeUpdateData', id)
      functions.routeSayfa("Yatırım Güncelle", this)
    },
    goEvrakDetay(id) {
      this.$store.commit('changeEvrakUpdateData', id)
      functions.routeSayfa("Evrak Güncelle", this)
    },
    goCalismaRuhsatDetay(data) {
      this.$store.commit('setCalismaUpdateData', data)
      functions.routeSayfa("Açma ve Çalışma Ruhsat Tanımla", this)
    },
    goYapiRuhsatDetay(data) {
      this.$store.commit('setYapiUpdateData', data)
      functions.routeSayfa("Yapı Ruhsat Tanımla", this)
    },
    goArsaDetay(data) {
      this.$store.commit('setArsaUpdateData', data)
      functions.routeSayfa("Arsa Tahsis Tanimla", this)
    },
    muhasebeDownloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = talimatService.dekontPath + item.dekont;
      downloadLink.download = item.dekont;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    adminLogDownloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = logService.variablePath + item.yol;
      downloadLink.download = item.yol;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    yaklasanTarihTurChange(val) {
      try {
        this.yaklasanTarihLoading = true;
        analitikService.yaklasanProjeler(val, this.tarihler.gun).then((response) => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token);
            this.tarihler.list = response.data
            this.tarihler.count = response.data.projeKayit
          }
        }).catch(err => {
          this.tarihler.list = []
          this.tarihler.count = 0
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 400) {
              this.tarihler.list = []
              this.tarihler.count = 0
              notification.Status("errorMsg", this, 'Kayıtlı veri Bulunamadı')
            }
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.bekleyenGelen = [];
            }
          }
          this.loading = false;
        }).finally(() => {
          this.yaklasanTarihLoading = false
        })
      } catch (e) {
        this.yaklasanTarihLoading = false;
        this.tarihler.list = []
        this.tarihler.count = 0
      }
    },
    yaklasanTarihGunChange(val) {
      try {
        this.yaklasanTarihLoading = true;
        analitikService.yaklasanProjeler(this.tarihler.tur, val).then((response) => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token);
            this.tarihler.list = response.data
            this.tarihler.count = response.data.projeKayit
          }
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 400) {
              this.tarihler.list = []
              this.tarihler.count = 0
              notification.Status("errorMsg", this, 'Kayıtlı veri Bulunamadı')
            }
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.bekleyenGelen = [];
            }
          }
        }).finally(() => {
          this.yaklasanTarihLoading = false
        })
      } catch (e) {
        this.tarihler.list = []
        this.tarihler.count = 0
        this.yaklasanTarihLoading = false;
      }
    },
    evrakUpload(file, row, tur) {
      this.$set(row, 'dosyaYuklendi', true);
      const item = {
        name: file.name,
        url: file.url,
        id: file.raw.lastModified,
        size: file.raw.size,
        yaziIsleriID: row.yaziIsleriID,
      };
      this.evrakListMain.push(item)
      file.raw["tmp_name"] = file.url;
      this.evrakForm.evrak.push(file.raw);
      this.$forceUpdate();
      //row.dosyaYuklendi = false;
      this.$confirm("Evrak Eklemek İstediğinize Emin Misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        this.guncellenenEvrakID = row.yaziIsleriID
        dosyaService.dosyaGuncelle(row.yaziIsleriID, row.cariID, row.konu, this.evrakForm.evrak[0]).then((response) => {
          if (response.status == 200) {
            this.getDashboard()
            localStorage.setItem("userDataDemirag", response.token)
            notification.Status("success", this, response.msg)
            this.evrak[tur].forEach(item => {
              if (item.yaziIsleriID == row.yaziIsleriID) item.dosyaAdi = response.data.dosyaAdi
            })
          }
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
        }).finally(() => {
          const findIndex = this.evrakListMain.findIndex(item => item.yaziIsleriID == row.yaziIsleriID)
          this.evrakListMain.splice(findIndex, 1)
          this.evrakForm.evrak = []
          this.guncellenenEvrakID = null
        })
      }).catch((e) => {
        const findIndex = this.evrakListMain.findIndex(item => item.yaziIsleriID == row.yaziIsleriID)
        this.evrakListMain.splice(findIndex, 1)
        this.evrakForm.evrak = []
      })
    },
    talimatUpload(file, row, formName) {
      this.$confirm("Dekont Eklemek İstediğinize Emin Misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        this.updateTalimatID = row.muhasebeID
        talimatService.dekontEkle(row.muhasebeID, file.raw, 'update').then((response) => {
          if (response.status == 200) {
            this.getDashboard()
            localStorage.setItem("userDataDemirag", response.token)
            notification.Status("success", this, response.msg)
            this.resetForm(formName)
          }
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else notification.Status("errorMsg", this, error.msg)
          } else {
            //notification.Status(503, this)
          }
        }).finally(() => {
          this.updateTalimatID = null
        })
      }).catch((e) => {
        this.dekontListMain = []
      })
    },
    evrakRemove() {
      $('#evrakEkle .el-upload--belge-card').show();
      this.dekontListMain = [];
      this.evrakListMain = [];
      this.evrakForm.evrak = [];
    },
    yapiDownloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = ruhsatService.path + item.dosyaYolu;
      downloadLink.download = item.dosyaYolu;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    calismaDownloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = calismaRuhsatService.path + item.dosyaYolu;
      downloadLink.download = item.dosyaYolu;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    arsaDownloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = arsaService.path + item.dosyaYolu;
      downloadLink.download = item.dosyaYolu;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    evrakDownloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = dosyaService.dosyaPath + item.dosyaAdi;
      downloadLink.download = item.dosyaAdi;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    getDashboard() {
      try {
        this.loading = true;
        this.isData = false
        analitikService.dashboardData().then((response) => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token);
            // ? EVRAK
            this.evrak.gelenEvrak = response.data.gelenEvrak;
            this.evrak.gidenEvrak = response.data.gidenEvrak;
            this.evrak.gelenEvrakCount = response.data.gelenEvrakKayit;
            this.evrak.gidenEvrakCount = response.data.gidenEvrakKayit;
            // ? ARSA
            this.arsa.tahsis = response.data.arsa;
            this.arsa.tahsisCount = response.data.arsaKayit;
            // ? YAPI RUHSAT
            this.arsa.yapi = response.data.yapiRuhsat;
            this.arsa.yapiCount = response.data.yapiRuhsatKayit;
            // ? ACMA CALISMA
            this.arsa.acma = response.data.calismaRuhsat;
            this.arsa.acmaCount = response.data.calismaRuhsatKayit;
            // ? YATIRIMCI
            this.yatirimci.list = response.data.yatirimci;
            // ? YATIRIM
            this.yatirim.list = response.data.yatirim;
            // ? MUHASEBE
            this.muhasebe.list = response.data.muhasebe;
            this.muhasebe.count = response.data.muhasebeKayit;
            // ? ADMIN LOG
            this.adminLog.list = response.data.silinenLog;
            this.adminLog.count = response.data.silinenLogKayit;
            // ? TARIHLER
            this.tarihler.list = response.data.proje
            this.tarihler.count = response.data.projeKayit
            // ? GIRILMEYEN TARIHLER
            this.girilmeyenTarihler.list = response.data.girilmeyenTarihler
            this.girilmeyenTarihler.count = response.data.girilmeyenTarihKayit
          }
          this.loading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.bekleyenGelen = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          }
          this.loading = false;
        }).finally(() => {
          this.isData = true
        })
      } catch (e) {
        this.loading = false;
      }
    },
    indexMethod(index) {
      return index + 1;
    },
  },
  created() {
  },
}

</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.edit-btn {
  background-color: #FDBF60 !important;
}

.el-collapse-item .el-row {
  top: 0;
  margin-bottom: 10px;
}

.upload-btn {
  height: 37px !important;
  background-color: red;
  border: none;
  width: 50px;
  place-content: center;
  place-items: center;
  display: flex;
}

.download-btn {
  background-color: #00A9FF;
  border: none;
  height: 37px !important;
  width: 50px;
  place-content: center;
  place-items: center;
  display: flex;
}

.centeredText {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.account-tab {

  .card-outline {
    min-height: 130px;
    border: 1px solid $text-color-accent;

    .title {
      font-size: 16px;
      margin-bottom: 10px;
      font-weight: bold;
      color: white;
      background: $text-color-accent;
      display: inline-block;
      position: relative;
      top: -24px;
      margin-left: -20px;
      padding: 4px 10px;
      text-transform: uppercase;
    }
  }

  .widget-profile {
    .avatar {
      width: 70px;

      img {
        width: 100%;
      }
    }

    .box.grow {
      height: 70px;
      padding: 0 20px;
      box-sizing: border-box;
      cursor: pointer;

      .since {
        font-size: 12px;
        opacity: .5;
      }

      &:hover {
      }
    }
  }

  .widget-order {
    .photo {
      width: 70px;

      img {
        width: 100%;
      }
    }

    .box.grow {
      height: 70px;
      padding: 0 20px;
      box-sizing: border-box;
      cursor: pointer;

      .date {
        font-size: 12px;
        opacity: .5;
      }

      &:hover {
      }
    }
  }

  .widget-achievements {
    .box.grow {
      height: 70px;
      line-height: 70px;
      font-size: 30px;
      box-sizing: border-box;
      text-align: center;
    }
  }

  .widget-address {
    .box.grow {
      height: 70px;
      padding: 0px 20px;
      box-sizing: border-box;
      cursor: pointer;

      .street {
        font-size: 12px;
        opacity: .5;
        margin-top: -5px;
      }

      &:hover {
      }
    }
  }
}

.widget {
  height: 250px;
  position: relative;

  .widget-header {

    .widget-icon-box {
      background: rgba(0, 0, 0, .02);
      border: 1px solid rgba(0, 0, 0, .02);
      border-radius: 4px;
      text-align: center;
      width: 80px;
      aspect-ratio: 1/1
    }

    .widget-title {
      cursor: pointer;
      font-weight: bold;
    }
  }

}

@media (min-width: 768px) and (max-width: 1040px) {
  .radio-switcher {
    display: none;
  }

  .widget {
    .widget-header {
      .widget-icon-box {
        display: none;
      }
    }
  }
}

@media (max-width: 420px) {
  .radio-switcher {
    display: none;
  }
}
</style>
<style lang="scss">
@import '../../assets/scss/_variables';

.dashboard-collapse-area {
  .el-badge__content {
    background-color: #00C4FF !important;
  }

  .yaklasan-tarihler-gun-checkbox {
    label {
      span {
        background-color: #4da8ff;
        color: white;
        border: none;
      }
    }
  }

  .yaklasan-tarihler-tur-checkbox {
    label {
      span {
        background-color: #4da8ff;
        color: white;
        border: none;
      }
    }
  }

  table {
    tr {
      th {
        background-color: #74cec3 !important;
        color: white;
      }
    }
  }
}

.dashboard-collapse-area .el-collapse-item__content {
  min-height: 257px !important;
}

.bg-accent {
  background-color: #21c1d666 !important;
}

.el-divider__text {
  background-color: #f2f7fa;
}

.page-dashboard {

  .widget {
    .peity {
      position: absolute;
      bottom: -1px;
      left: 0;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  table.styled {
    .peity {
      margin-right: 10px;
    }
  }

  .vb-content {
    padding: 0 20px;
    box-sizing: border-box !important;
    margin-top: -5px;
    margin-left: -20px;
    margin-right: -20px;
    height: calc(100% + 15px) !important;
    width: calc(100% + 40px) !important;
  }
}

@media (max-width: 768px) {
  .page-dashboard {
    .vb-content {
      padding: 0 5px !important;
      margin: -5px;
      width: calc(100% + 10px) !important;
    }
  }
}

.account-tab .widget-address .box.grow .street {
  font-size: 12px;
  opacity: .5;
  margin-top: -5px;
}

.page-dashboard {
  .el-collapse-item {
    box-shadow: 0 8px 16px 0 rgba(40, 40, 90, .09), 0 3px 6px 0 rgba(0, 0, 0, .065);
    border-radius: 5px;

    .el-collapse-item__header {
      cursor: pointer !important;
      font-size: 14px !important;
      font-weight: 500;
      height: 40px;
      background-color: $dashboard-collapse-header !important;
      color: $background-color !important;
      font-weight: 500;
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    .el-collapse-item__wrap {
      border-bottom: none;
    }
  }

  .widget-info {
    h2 {
      font-size: 20px !important;
      line-height: 1.4;
    }

    .widget-title {
      font-size: 14px !important;
      line-height: 1.4;
    }

    button {
      z-index: 99;
      position: relative;
    }
  }
}

.header-red {
  .el-collapse-item {
    .el-collapse-item__header {
      background-color: rgb(194, 17, 4) !important;
    }
  }
}

.delay-200ms {
  animation-delay: 200ms;
}
</style>
<style>

table.styled thead tr th {
  color: rgb(2, 88, 88);
  background-color: rgb(231, 241, 239);
  line-height: 15px;
}

.satir {
  font-size: 13px;
  line-height: 15px;
}


.el-badge__content {
  background-color: red !important;
  color: white;
  width: 25px;
  height: 25px;
  padding: 0;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 16px;
  font-weight: 450;
  margin-bottom: -20px !important;
  margin-left: -10px
}

.anasayfa .el-badge__content.is-fixed {
  position: absolute;
  top: 0;
}

.el-loading-spinner {
  color: #048484;
  margin: 60px 0;
  font-size: 14px;
}

</style>

